<pc-overlay [config]="{ title: 'Assign Metrics' }" (closeClick)="billing.showAssignMetricsModal$.next(false)">
  <ng-container body>
    @if (selectableMetrics.length === 0) {
      <div style="width: 100%">
        <div style="font-size: 20px; margin: 20px 0">{{ 'STORE.PLEASE_ADD_COMPATIBLE_DEVICES' | translate }}</div>
        <div style="margin-top: 20px">
          <pc-button
            [text]="'STORE.OPEN_FAQ' | translate"
            (btnClick)="ui.openURL('https://proficloud.io/knowledge-hub/faqs/general/which-device-can-use-which-smart-service/')"></pc-button>
        </div>
      </div>
    }

    <!-- used metric slots info -->
    <div style="width: 100%">
      <div
        style="margin-bottom: 15px"
        [innerHTML]="
          'USR_SETTINGS.TSD_GENERAL_SLOT_INFORMATION'
            | translate
              : {
                  param1: billing.tsdTotalMetricsUsed,
                  param2: tempAssignedMetrics$ | async,
                  param3: billing.bookedTsdPackage?.maxNumberOfMetrics,
                }
        "></div>
    </div>

    @if (selectableMetrics.length > 0) {
      <div style="width: 100%">
        <!-- filter -->
        <div class="filter-container">
          <pc-icon class="search-icon" [color]="'gray'" name="search"> </pc-icon>
          <input class="filter-input" (input)="queryTsdDevices($event.target.value)" placeholder="Metric Search" />
        </div>
        <div style="width: 100%; max-height: 60vh; overflow-y: scroll">
          @for (selectableMetric of selectableMetrics; track selectableMetric.device.endpointId) {
            @if (selectableMetric.show) {
              <div class="select-header">
                <div class="device-name select-header-text" [title]="selectableMetric.device.metadata.deviceName">
                  {{ selectableMetric.device.metadata.deviceName }}
                </div>
                <div class="device-uuid select-header-text" [title]="selectableMetric.device.metadata.uuid">{{ selectableMetric.device.metadata.uuid }}</div>
              </div>
              @if (selectableMetric.selectableMetrics.length === 0) {
                <div style="padding: 20px; font-style: italic; color: #555">No matching metrics found</div>
              } @else {
                <pc-input-select-multiple-table
                  [config]="selectableMetric.config"
                  [selectValues]="selectableMetric.selectableMetrics"
                  (valueChanged)="countTempAssignedMetrics()"></pc-input-select-multiple-table>
              }
              <div class="separator"></div>
            }
          }
        </div>
        <flex-row-end style="margin-top: 20px">
          <pc-button id="edit-save" [text]="'STORE.ASSIGN_METRICS' | translate" (btnClick)="assignMetricsClick()"></pc-button>
        </flex-row-end>
      </div>
    }
  </ng-container>
</pc-overlay>
